import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { setFirstVisit, toggleTour } from "../actions/settingActions";

import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Tooltip from "@material-ui/core/Tooltip";

const styles = (theme) => ({
  label: {
    fontSize: "0.9rem",
    color: "grey",
  },
  tooltip: {
    backgroundColor: "white",
    color: "#00568E",
    fontSize: "9pt",
    border: "1px solid #00568E",
  },
});

class Prompt extends Component {
  state = {
    checked: false,
  };

  onChange = (e) => {
    if (e.target.checked) {
      window.localStorage.setItem("prompt", e.target.checked);
      this.setState({ checked: true });
    } else {
      window.localStorage.removeItem("prompt");
      this.setState({ checked: false });
    }
  };

  startTour = () => {
    this.props.setFirstVisit();
    this.props.history.push("/muehlenkataster");
    this.props.toggleTour();
  };

  render() {
    return (
      <Dialog
        onClose={this.props.setFirstVisit}
        open={this.props.prompt}
        style={{ zIndex: 1304 }}
        maxWidth={"sm"}
      >
        <DialogTitle style={{ color: "#00568E", paddingBottom: "5px" }}>
          <div style={{ fontWeight: "600" }}>Mühlen im Kreis Herford</div>
        </DialogTitle>
        <DialogContent>
          {/* 1995 erschien das Buch „Mühlen im Kreis Herford. Historisches
          Kataster“. Darin sind alle Mühlenstandorte erfasst, die der Historiker
          Christoph Mörstedt im Auftrag des Kreises Herford ermittelt und
          dokumentiert hatte.
          <p style={{ marginTop: "20px", marginBottom: 0 }}>
            <b>
              Alle Angaben beziehen sich auf den Erfassungszeitraum (1990-1995).
            </b>
          </p> */}
          <p>
            Das Mühlenkataster des Kreises Herford geht auf eine
            Forschungsarbeit zurück. Sie hat 1987 bis 1991 stattgefunden.
            Gesucht und dokumentiert wurden alle Mühlenstandorte, die seinerzeit
            vorhandenen wie die schon früher verschwundenen.{" "}
            <text
              className="appLink"
              style={{ cursor: "pointer" }}
              onClick={() => {
                this.props.setFirstVisit();
                this.props.history.push(
                  this.props.location.pathname + "#einleitung"
                );
              }}
            >
              Mehr anzeigen
            </text>
          </p>
          <p>
            Hat sich bei Ihnen um die Ecke vielleicht auch mal eine Mühle
            befunden? Wir wünschen viel Freude beim Stöbern und Entdecken –
            Klicken Sie sich um!
          </p>
          <p style={{ marginBottom: 0, justifyContent: "center" }}>
            <Tooltip
              placement="top"
              title="Kreis Herford"
              classes={{
                tooltip: this.props.classes.tooltip,
              }}
            >
              <a
                href="https://www.kreis-herford.de/"
                target="_blank"
                rel="noopener noreferrer"
                title=""
                style={{ marginRight: "40px" }}
              >
                <img
                  alt=""
                  src={
                    "https://geoportal.kreis-herford.de/images/kreisherford.svg"
                  }
                  height="55"
                  style={{ marginTop: "20px" }}
                />
              </a>
            </Tooltip>
            <Tooltip
              placement="top"
              title="Geoportal Kreis Herford"
              classes={{
                tooltip: this.props.classes.tooltip,
              }}
            >
              <a
                href="https://geoportal.kreis-herford.de/#geschichte"
                target="_blank"
                rel="noopener noreferrer"
                title="Geoportal Kreis Herford"
                style={{ marginRight: "40px" }}
              >
                <img
                  alt=""
                  src={`${process.env.PUBLIC_URL}/logo_geoportal.svg`}
                  height="55"
                  style={{ marginTop: "20px" }}
                />
              </a>
            </Tooltip>
            <Tooltip
              placement="top"
              title="Kreisheimatverein Herford e.V."
              classes={{
                tooltip: this.props.classes.tooltip,
              }}
            >
              <a
                href="https://www.kreisheimatverein.de/"
                target="_blank"
                rel="noopener noreferrer"
                title=""
              >
                <img
                  alt=""
                  src={`${process.env.PUBLIC_URL}/kreis_heimatverein.png`}
                  height="55"
                  style={{ marginTop: "20px" }}
                />
              </a>
            </Tooltip>
          </p>
        </DialogContent>
        <DialogActions>
          <FormControlLabel
            style={{ flexGrow: 1, marginLeft: "8px" }}
            classes={{ label: this.props.classes.label }}
            control={
              <Checkbox
                size={"small"}
                value={true}
                checked={this.state.checked}
                onChange={(e) => this.onChange(e)}
                name="dialog"
                color="primary"
              />
            }
            label={"Dialog nicht mehr anzeigen"}
          />
          <Button variant="contained" color="primary" onClick={this.startTour}>
            Tour starten
          </Button>
          <Button
            style={{ marginRight: "8px" }}
            variant="outlined"
            color="primary"
            onClick={this.props.setFirstVisit}
          >
            Schließen
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

Prompt.propTypes = {
  prompt: PropTypes.bool.isRequired,
  setFirstVisit: PropTypes.func.isRequired,
  toggleTour: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  prompt: state.settings.prompt,
});

export default connect(mapStateToProps, { setFirstVisit, toggleTour })(
  withRouter(withStyles(styles, { withTheme: true })(Prompt))
);
